/**
 * @module app.core
 */

import { autoinject } from "aurelia-framework";
import { ComponentBase, IWindowMessage } from 'app/shared/lib/essette-site';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { TitleChangeEvent, MenuRefreshEvent } from 'app/shared/lib/events';


export interface ITransitionalPageParameters {
    pageId: string;
    /** Pipe-delimited list of transitional Ids (e.g. 123|CM.Case|456) */
    transitionalIds?: string;
    ids?: string;
    inboundRoute?: string;
    inboundQuery?: string;
}

@autoinject()
export class TransitionalPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    private pageId: string | null = null;
    private transitionalIds: string[] = [];
    private moduleCode: string = "";
    public pageTitle: string | null;
    public ariaLabel: string | null = null;
    public titleChangeEvent: Subscription | null;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected transitional: TransitionalManager,
        private readonly events: EventAggregator,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
        this.titleChangeEvent = null;
        this.pageTitle = null;
    }

    protected async activate(params: ITransitionalPageParameters): Promise<void> {
        if(params) {
            if(params.inboundRoute && params.inboundQuery) {
                this.transitional.navigate(params.inboundRoute, params.inboundQuery);
                return;
            }
            if(this.pageId !== params.pageId) { this.pageId = params.pageId; }
            if(params.transitionalIds || params.ids) {
                // In most cases we are using the "transitional-ids" as the querystring parameters.  In cases where we are re-routing and need to
                // pass along our own parameters, we had to use a different variable name and just went with "ids".  Think of it as a fallback method
                // of getting parameters to the transitional page.  Currently, this is only used when navigating to Izenda reports, which requires the
                // "rn" querystring parameter, and we set in the `navigateToIzendaReport()` function in core's `module.ts` file.
                const ids = params.transitionalIds || params.ids || '';

                // decode transitional id (querystring parameter). encoded in transitional/manager.ts. double-encoded for Izenda in core/module.ts
                this.transitionalIds = ids.split('|').map(decodeURIComponent);
            }
        }
    }

    protected attached(): void {
        if(this.pageId) {
            const f: HTMLFrameElement = <HTMLFrameElement><unknown>document.getElementById('transitionalFrame');
            if(f.contentWindow) { this.transitional.openTransitional(f.contentWindow, this.pageId, this.transitionalIds, this.moduleCode); }

            this.transitional.listenForPostMessages();
            this.titleChangeEvent = this.events.subscribe(TitleChangeEvent, (e: TitleChangeEvent) => {
                if(e.title) { this.pageTitle = this.ariaLabel = e.title[e.title.length - 1]; }
            });
        }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ***********************************************////


}
